module.exports = __webpack_public_path__ + "media/applicants/in-store-shopper-4cf0325f.jpg";